import { TemplateEngine } from "../../../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../../../js/main/constants";
import { ApplicationData } from "../../../ApplicationData";
import { SimpleErrorDialog } from "../../../controls/simpleErrorDialog";
import { SuccessMessageControl } from "../../../controls/successMessageControl";
import { MyAccountBaseSubView } from "../BaseSubView";

export class LandingPageConfigView extends MyAccountBaseSubView {
  constructor(options) {
    options = options || {};
    options.template =
      "tmpl/myAccount/config/landingPage/landingPageConfig.html";
    options.viewName =
      LS2PAC_CONSTANTS.Ids.MyAccountPage.tabs.landingPageConfig;
    options.id = options.viewName;
    options.tabText = ApplicationData.language.landingPageConfiguration;
    super(options);

    this.MAX_LISTS = 5;

    this.config = null;

    this.addListener(LS2PAC_CONSTANTS.Events.onGetLandingPageConfigResponse, (event) => {
      this.renderResourceLists(event.data);
    });

    //TODO these two might overlap each other if you click the radio buttons quick enough
    this.addListener(
      LS2PAC_CONSTANTS.Events.onGetStaticConfigListsResponse,
      (event) => {
        this.showOrHideListOptions(event.lists, "static");
        this.renderStaticConfigListsOptions(event.lists);
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onGetDynamicConfigListsResponse,
      (event) => {
        this.showOrHideListOptions(event.lists, "dynamic");
        this.renderStaticConfigListsOptions(event.lists);
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onUpdateLandingPageConfigResponse,
      (event) => {
        if (event.success === true) {
          SuccessMessageControl.show(
            ApplicationData.language.successUpdatingLandingPageConfig
          );
          this.renderResourceLists(event.data);
        } else {
          SimpleErrorDialog.show(
            ApplicationData.language.errorUpdatingLandingPageConfig
          );
        }
      }
    );
  }
  fetchData() {
    TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetLandingPageConfig);
  }
  showOrHideListOptions(lists, type) {
    var listForm = $(".configListForm").find("." + type);
    if (lists.length > 0) {
      listForm.find(".hasLists").show();
      listForm.find(".noLists").hide();
    } else {
      listForm.find(".hasLists").hide();
      listForm.find(".noLists").show();
    }
  }
  getSelectOptionsForList(lists, valueProperty, displayProperty) {
    var listOptions = [],
      j = 0;
    $.each(lists, function (i, list) {
      listOptions[j++] = '<option value="';
      listOptions[j++] = list[valueProperty];
      listOptions[j++] = '">';
      listOptions[j++] = list[displayProperty];
      listOptions[j++] = "</option>";
    });
    return listOptions.join("");
  }
  renderStaticConfigListsOptions(lists) {
    $("#listId")
      .empty()
      .append(this.getSelectOptionsForList(lists, "id", "name"))
      .prop("disabled", false);
  }
  sortConfigByDisplayOrder(config) {
    config.resourceLists.sort(function (a, b) {
      return a.displayOrder - b.displayOrder;
    });
    return config;
  }
  renderResourceLists(config) {
    this.config = config;
    config = this.sortConfigByDisplayOrder(config);

    TemplateEngine.fetch(
      "tmpl/myAccount/config/landingPage/resourceListRow.html",
      $("#carouselOrder"),
      config.resourceLists,
      function () {},
      TemplateEngine.method.overwrite
    );

    if (config.resourceLists.length >= this.MAX_LISTS) {
      $("#" + this.id)
        .find(".addSection")
        .hide();
      $("#" + this.id)
        .find(".maxedOut")
        .show();
    } else {
      $("#" + this.id)
        .find(".addSection")
        .show();
      $("#" + this.id)
        .find(".maxedOut")
        .hide();
    }
  }
  save() {
    var config = this.sortConfigByDisplayOrder(this.config);
    TLCEventManager.fireEvent(
      LS2PAC_CONSTANTS.Events.onUpdateLandingPageConfig,
      { data: config }
    );
  }
  updateResourceListDisplayOrder(resourceListId, index) {
    $.each(this.config.resourceLists, function (i, resourceList) {
      if (resourceList.id == resourceListId) {
        resourceList.displayOrder = index;
        return false;
      }
    });
  }
  onUpdateOrder(event, ui) {
    var _this = this;
    $("#carouselOrder")
      .find("li")
      .each(function (index, element) {
        _this.updateResourceListDisplayOrder(element.id, index);
      });
    _this.save();
  }
  removeResourceListById(resourceListId) {
    var temp = $.grep(
      this.config.resourceLists,
      function (resourceList, index) {
        return resourceList.id !== parseInt(resourceListId, 10);
      }
    );
    this.config.resourceLists = temp;
    TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onRemoveResourceList, {
      id: resourceListId,
    });
  }
  onRemoveResourceList(resourceListId) {
    //remove the list from the dom
    $("#" + resourceListId).remove(); //TODO is this necessary - do we re-render anyway after saving?

    //remove the list from the config
    this.removeResourceListById(resourceListId);
  }
  hideAddForm() {
    $(".selectNewFeature").fadeOut("slow", function () {
      $("#configList").trigger("click");
      $(".configListForm").empty();
      $(".addNewLink").fadeIn("slow");
    });
  }
  showAddForm(type) {
    switch (type) {
      case "newReleases":
        this.showNewReleasesForm();
        break;
      case "configSearch":
        this.showDynamicListsForm();
        break;
      case "externalUrl":
        this.showExternalUrlForm();
        break;
      case "configList":
        this.showStaticListsForm();
        break;
    }
  }
  addEvents() {
    $("#carouselOrder").sortable({
      placeholder: "footprint",
      update: (event, ui) => {
        this.onUpdateOrder(event, ui);
      },
    });
    $("#carouselOrder").disableSelection();

    this.addEventHandler($("#carouselOrder"), "click", ".removeResourceListLink", (event) => {
      var parentId = $(event.currentTarget).parent("li").attr("id");
      this.onRemoveResourceList(parentId);
      return false;
    });

    this.addEventHandler($("#" + this.id), "click", ".cancelAddLink", (event) => {
      this.hideAddForm();
      return false;
    });

    this.addEventHandler($("#" + this.id), "click", ".addNewLink", (event) => {
      $(event.currentTarget).fadeOut("slow", () => {
        $(".selectNewFeature").fadeIn("slow"); //TODO use an ID here
        var featureType = $("input[name='featureType']:checked").val();
        this.showAddForm(featureType);
      });
      return false;
    });

    this.addEventHandler($("#" + this.id), "change", "input[name='featureType']", (event) => {
      this.showAddForm($(event.currentTarget).val());
    });

    this.addEventHandler($("#" + this.id), "click", ".submitAddLink", (event) => {
      var featureType = $("input[name='featureType']:checked").val();
      switch (featureType) {
        case "newReleases":
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onAddNewReleases, {
            range: $("#range").val(),
            name: $("#name").val(),
            caption: $("#caption").val(),
          });
          break;
        case "externalUrl":
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onAddExternalResourceList,
            {
              data: {
                url: $("#url").val(),
                name: $("#name").val(),
                caption: $("#caption").val(),
              },
            }
          );
          break;
        case "configSearch":
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onAddDynamicResourceList,
            {
              id: $("#listId").val(),
              caption: $("#caption").val(),
            }
          );
          break;
        case "configList":
          TLCEventManager.fireEvent(
            LS2PAC_CONSTANTS.Events.onAddStaticResourceList,
            {
              id: $("#listId").val(),
              caption: $("#caption").val(),
            }
          );
          break;
      }
      this.hideAddForm();
      return false;
    });

  }
  showNewReleasesForm() {
    TemplateEngine.fetch(
      "tmpl/myAccount/config/landingPage/newReleasesForm.html",
      $(".configListForm"),
      {
        ranges: this.getSelectOptionsForList(
          LS2PAC_CONSTANTS.RecentAdditionsRange,
          "key",
          "display"
        ),
      },
      function () {},
      TemplateEngine.method.overwrite
    ); //TODO make sure nothing is delegated below this level
  }
  showStaticListsForm() {
    TemplateEngine.fetch(
      "tmpl/myAccount/config/landingPage/staticListForm.html",
      $(".configListForm"),
      {},
      function () {
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onGetStaticConfigLists
        );
      },
      TemplateEngine.method.overwrite
    );
  }
  showDynamicListsForm() {
    TemplateEngine.fetch(
      "tmpl/myAccount/config/landingPage/dynamicListForm.html",
      $(".configListForm"),
      {},
      function () {
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onGetDynamicConfigLists
        );
      },
      TemplateEngine.method.overwrite
    );
  }
  showExternalUrlForm() {
    TemplateEngine.fetch(
      "tmpl/myAccount/config/landingPage/externalUrlForm.html",
      $(".configListForm"),
      {},
      function () {},
      TemplateEngine.method.overwrite
    );
  }
  isDefaultView() {
    return this.showHideLogic();
  }
}
